import { render, staticRenderFns } from "./customer-create.vue?vue&type=template&id=59141726&scoped=true&"
import script from "./customer-create.vue?vue&type=script&lang=js&"
export * from "./customer-create.vue?vue&type=script&lang=js&"
import style0 from "./customer-create.vue?vue&type=style&index=0&id=59141726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59141726",
  null
  
)

export default component.exports